import React, { useCallback } from 'react';
import { useModal } from '../ModalProvider';
import { ModalProps, ModalType } from '../../interfaces';

export interface Returned<P extends Record<string, any> = any> {
    open: (props: P) => void;
}

export const useModalGeneralForPublic = <P extends ModalProps = any>(
    Component: React.FC<P>,
    type: ModalType,
    queryName?: string,
): Returned => {
    const { pushModal } = useModal();

    const open = useCallback(
        (props: P) => {
            pushModal({
                type,
                Component,
                props,
                queryName,
            });
        },
        [pushModal, Component, queryName],
    );

    return { open };
};
